import {
  Grid,
  Tooltip,
  Button,
  Snackbar,
  Alert,
  Typography,
  Backdrop,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
  Box,
  Paper,
  TablePagination,
  Checkbox,
} from "@mui/material";
import { TextField } from "@mui/material";
import { InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import { useEffect, useState, useRef } from "react";
import egressService from "../../services/egressService";
import warehouseService from "../../services/warehouseService";
import { printZpl, getPrinterConfig } from "../../services/qzPrint";
import { buildBultoLabel } from "../../utils/buildBultoZpl";
import * as styles from "./styles";
import { formatDateString } from "../../helpers";
import { Link, useNavigate } from "react-router-dom";
import { returnRol } from "../../utils/constants";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterModal from "../../components/MFilters/index.js";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import ingressService from "../../services/ingressService.js";
import integrationService from "../../services/integrationService.js";
import usageService from "../../services/usageService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TakeoutDiningIcon from '@mui/icons-material/TakeoutDining';
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ModalAccepted from "./modals/modalAccepted.js";
import ModalPrepared from "./modals/modalPrepared.js";
import ModalView from "../egress/modals/modalView.js";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ModalDispatched from "../egress/modals/modalDispatched.js";
import CircularProgress from "@mui/material/CircularProgress";
import LogoPdf from "../../../src/assets/LogoPdf.png";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import AuthService from "../../services/authService.js";
import TablaGenerica from "../../components/Table/tablaGenerica.js";
import PrintIcon from "@mui/icons-material/Print";
import CancelIcon from "@mui/icons-material/Cancel";
import EgressLabelPrinter from "../egress/createEgress/labelPrinterEgress";
import EgressLimitModal from "../../components/EgressLimitModal";
import {
  warehouseRemitenteLines,
  warehouseRemitenteOneLine,
} from "../../utils/remitente";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// Fecha "de la venta": la del canal (integration.transaction_date) para egresos de
// integraciones —coincide con el panel de ML/TN/Woo—, o la de creación para manuales.
const saleDate = (rowData) =>
  rowData?.integration?.transaction_date || rowData?.date_created;

// Seguimiento del envío del canal (ML): mapea status/substatus del shipment al chip
// vivo de la tarjeta. Devuelve null si no hay datos (canales sin tracking automático).
const channelTracking = (status, substatus) => {
  if (!status) return null;
  const sub = (substatus || "").toLowerCase();
  switch ((status || "").toLowerCase()) {
    case "pending":
    case "handling":
      return { label: "⏳ ML preparando envío", bg: "#F1F5F9", color: "#475569" };
    case "ready_to_ship":
      if (sub === "printed") return { label: "🖨 Etiqueta impresa", bg: "#EFF6FF", color: "#1D4ED8" };
      return { label: "🏷 Etiqueta lista", bg: "#EFF6FF", color: "#1D4ED8" };
    case "shipped":
      if (sub === "out_for_delivery") return { label: "📍 En reparto", bg: "#FEF3C7", color: "#92400E" };
      return { label: "🚚 En camino", bg: "#FEF3C7", color: "#92400E" };
    case "delivered":
      return { label: "✅ Entregado", bg: "#DCFCE7", color: "#166534" };
    case "not_delivered":
    case "undelivered":
    case "returned":
      return { label: "⚠️ Problema de entrega", bg: "#FEE2E2", color: "#991B1B" };
    case "cancelled":
      return { label: "✖ Envío cancelado", bg: "#FEE2E2", color: "#991B1B" };
    default:
      return null;
  }
};

// Sub-filtros de seguimiento dentro del tab Despachados.
const TRACKING_SUBFILTERS = [
  { key: undefined, label: "Todos" },
  { key: "en_camino", label: "🚚 En camino" },
  { key: "en_reparto", label: "📍 En reparto" },
  { key: "entregado", label: "✅ Entregados" },
  { key: "problema", label: "⚠️ Con problema" },
];

const isMercadoLibreIntegration = (rowData) => {
  const name = rowData?.integration?.name;
  if (!name || typeof name !== "string") return false;
  const n = name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return n.includes("mercado libre") || n.includes("mercadolibre");
};

// Sentinels de MercadoEnvíos (Camino A): la etiqueta la genera Mercado Libre, el
// operario NO asigna operativa. Full no aparece en la lista (no genera egreso).
// ME1 llega con shipping_method vacío → sí pide operativa (como Woo/TN).
const ML_SHIPPING_MODES = {
  me_flex: "Flex",
  me2: "MercadoEnvíos",
};
const isMlShippingMode = (m) => !!ML_SHIPPING_MODES[String(m || "").toLowerCase()];

// Referencia de la venta para mostrar: preferimos el número "lindo" del canal
// (TiendaNube #9929); si no viene (Woo/ML: id == número), caemos al transaction_id.
const formatSaleRef = (integration) => {
  if (!integration) return "—";
  const num = integration.transaction_number;
  if (num && num !== "0") return `#${num}`;
  return integration.transaction_id ? `#${integration.transaction_id}` : "—";
};

// Una venta de integración que todavía no tiene operativa asignada. No se puede
// preparar hasta asignarla. Criterio uniforme: cualquier canal (ML ME1 incluido)
// con shipping_method vacío. Flex/ME2 traen sentinel → ya resueltas.
const needsOperativa = (rowData) => {
  if (!rowData?.integration) return false;
  return !rowData.shipping_method;
};

// Canal de venta: de dónde vino el egreso. "manual" = egreso sin integración.
// El value coincide con integration_name del backend (en minúscula).
const SALES_CHANNEL_OPTIONS = [
  { value: "manual", label: "Manual" },
  { value: "woocommerce", label: "WooCommerce" },
  { value: "mercadolibre", label: "MercadoLibre" },
  { value: "tiendanube", label: "TiendaNube" },
];

// Opciones del filtro de Operativa. "sin_asignar" (sentinel) = egresos sin operativa
// asignada. El resto coincide con los valores de shipping_method del backend.
const OPERATIVA_OPTIONS = [
  { value: "sin_asignar", label: "⚠ Sin asignar" },
  { value: "cliente", label: "Cliente retira" },
  { value: "red_despacho", label: "Despacho" },
  { value: "redespacho", label: "Redespacho" },
  { value: "transporte_manual", label: "Transporte retira" },
  { value: "me_flex", label: "MercadoEnvíos Flex" },
  { value: "me2", label: "MercadoEnvíos (ME2)" },
];

// Provincias argentinas para el filtro por destino.
const AR_PROVINCES = [
  "Buenos Aires", "CABA", "Catamarca", "Chaco", "Chubut", "Córdoba",
  "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa", "La Rioja",
  "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta", "San Juan",
  "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero",
  "Tierra del Fuego", "Tucumán",
];

// Nombres de plataforma con el casing correcto para mostrar. El backend los
// guarda en minúscula (woocommerce/mercadolibre/tiendanube); acá los formateamos
// solo para la UI, sin tocar el dato.
const PLATFORM_LABELS = {
  woocommerce: "WooCommerce",
  mercadolibre: "MercadoLibre",
  tiendanube: "TiendaNube",
};

const formatPlatformName = (name) => {
  if (!name || typeof name !== "string") return name;
  const key = name.toLowerCase().replace(/\s+/g, "");
  return PLATFORM_LABELS[key] || name;
};

const parseLogistics = (logistics) => {
  if (!logistics) return {};
  if (typeof logistics === "string") {
    try {
      return JSON.parse(logistics);
    } catch {
      return {};
    }
  }
  return logistics;
};

const thirdPartyCarrierFromLogistics = (logistics) => {
  const L = parseLogistics(logistics);
  const dd = L.deliveryDetails || L.delivery_details || {};
  const tpc = dd.thirdPartyCarrier || dd.third_party_carrier;
  if (!tpc) return undefined;
  const mapLeg = (leg) => {
    if (!leg) return {};
    return {
      companyName: leg.companyName ?? leg.company_name ?? "",
      licensePlate: leg.licensePlate ?? leg.license_plate ?? "",
      phone: leg.phone ?? leg.telefono ?? "",
    };
  };
  const out = {
    intermediate: mapLeg(tpc.intermediate),
    final: mapLeg(tpc.final),
  };
  const hasAny =
    out.intermediate.companyName ||
    out.intermediate.phone ||
    out.intermediate.licensePlate ||
    out.final.companyName ||
    out.final.phone ||
    out.final.licensePlate;
  return hasAny ? out : undefined;
};

const initialAlert = {
  severity: "success",
  message: "",
};

const formatShippingMethod = (method) => {
  if (!method) return "No definido";
  const ml = { me_flex: "MercadoEnvíos Flex", me2: "MercadoEnvíos (ME2)" };
  if (ml[String(method).toLowerCase()]) return ml[String(method).toLowerCase()];
  return method
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const renderEgressPdfHeader = (
  doc,
  optimizedLogo,
  title = "DETALLE DE EGRESO",
  remitenteSrc = null
) => {
  doc.setFont("Helvetica");

  const logoWidth = 25;
  const logoHeight = 20;
  doc.addImage(
    optimizedLogo,
    "PNG",
    170,
    10,
    logoWidth,
    logoHeight,
    undefined,
    "FAST"
  );

  doc.setFontSize(20);
  doc.setFont("Helvetica", "bold");
  doc.text(title, 105, 20, { align: "center" });

  doc.setFontSize(12);
  doc.setFont("Helvetica", "normal");
  // Remitente = depósito de origen (configurable en /profile). Si no hay datos
  // cargados, al menos sale el nombre del depósito.
  const lines = warehouseRemitenteLines(remitenteSrc);
  let y = 30;
  (lines.length ? lines : [""]).slice(0, 3).forEach((ln) => {
    doc.text(ln, 105, y, { align: "center" });
    y += 5;
  });

  doc.line(15, 45, 195, 45);

  return 55;
};

const renderBulkSummaryPage = (doc, optimizedLogo, details) => {
  let verticalSpace = renderEgressPdfHeader(
    doc,
    optimizedLogo,
    undefined,
    Array.isArray(details) ? details[0] : null
  );

  doc.setFontSize(10);
  doc.setFont("Helvetica", "bold");
  doc.text(`Resumen de egresos aceptados (${details.length})`, 20, verticalSpace);

  doc.setFont("Helvetica", "normal");
  verticalSpace += 8;

  const currentDate = new Date().toLocaleDateString();
  doc.text(`Fecha de Creación: ${currentDate}`, 20, verticalSpace);
  doc.text(`Cantidad de pedidos: ${details.length}`, 110, verticalSpace);

  verticalSpace += 6;
  doc.line(15, verticalSpace, 195, verticalSpace);

  verticalSpace += 10;

  const summaryRows = details.flatMap((detail) =>
    (detail.movement_details || []).map((product) => [
      detail.id,
      detail.provider_name || "-",
      detail.phone_number || "-",
      product.sku_id || product.product_id || "-",
      product.description || "-",
      product.original_count ?? 0,
    ])
  );

  autoTable(doc, {
    startY: verticalSpace,
    head: [["Id Orden", "Cliente", "Teléfono", "SKU", "Descripción", "Cantidad"]],
    body: summaryRows.length
      ? summaryRows
      : [["-", "-", "-", "-", "Sin productos", 0]],
    columnStyles: {
      0: { cellWidth: 22 },
      1: { cellWidth: 38 },
      2: { cellWidth: 28 },
      3: { cellWidth: 22 },
      4: { cellWidth: 55 },
      5: { cellWidth: 20 },
    },
    styles: {
      overflow: "linebreak",
      halign: "center",
      valign: "middle",
      fontSize: 10,
      cellPadding: 3,
    },
  });

  verticalSpace = doc.lastAutoTable.finalY + 10;

  const totalProductos = details.reduce(
    (total, detail) => total + (detail.movement_details?.length || 0),
    0
  );
  const totalUnidades = details.reduce(
    (total, detail) =>
      total +
      (detail.movement_details || []).reduce(
        (sum, product) => sum + (product.original_count || 0),
        0
      ),
    0
  );

  doc.setFont("Helvetica", "bold");
  doc.text(`Total de pedidos: ${details.length}`, 20, verticalSpace);
  verticalSpace += 5;
  doc.text(`Total de productos: ${totalProductos}`, 20, verticalSpace);
  verticalSpace += 5;
  doc.text(`Total de unidades: ${totalUnidades}`, 20, verticalSpace);
};

const snapshotEgress = (egress) => JSON.parse(JSON.stringify(egress));

const normalizeEgressId = (id) => Number(id);

const ListadoEgresos = () => {
  const hasCreatePermission = AuthService.hasPermission("create", "movement_out");
  const [listadoDeEgresos, setListadoDeEgresos] = useState([]);
  const [statusCounts, setStatusCounts] = useState({});
  const [scanOnPrepare, setScanOnPrepare] = useState(true);
  const [autoPrintOnConfirm, setAutoPrintOnConfirm] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [alertObj, setAlertObj] = useState(initialAlert);
  const [buscandoEgresos, setBuscandoEgresos] = useState(false);
  const [refreshingSales, setRefreshingSales] = useState(false);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [selectedOperativa, setSelectedOperativa] = useState(null);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [searchText, setSearchText] = useState("");
  const searchFirstRender = useRef(true);
  const [ingressDetail, setIngressDetail] = useState({});
  const [movementDetails, setMovementDetails] = useState({});
  const [modalPending, setModalPending] = useState(false);
  const [modalDone, setModalDone] = useState(false);
  // red_despacho: bultos cargados en la creación, traídos al abrir la packing station
  // para preservarlos al confirmar "prepared" (el update reescribe movement_package).
  const [preparePackages, setPreparePackages] = useState([]);
  const [modalView, setModalView] = useState(false);
  const [modalDispatched, setModalDispatched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [labelsToPrint, setLabelsToPrint] = useState([]);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [selectedEgressIdForCancel, setSelectedEgressIdForCancel] =
    useState(null);
  const [cancelingEgress, setCancelingEgress] = useState(false);
  const [selectedPendingIds, setSelectedPendingIds] = useState([]);
  // Cartel de límite de plan (soft-cap): se llena al recibir 402 egress_limit_reached
  // al intentar Preparar (con el cupo lleno las ventas entran pero no se procesan).
  const [limitModal, setLimitModal] = useState(null);
  // Uso del cupo del plan: se consulta al montar para BLOQUEAR "Preparar" en el primer
  // click (sin hacer pasar al operario por el modal de confirmación). El 402 del
  // backend queda como defensa si el estado quedó viejo.
  const [egresoUsage, setEgresoUsage] = useState(null);

  useEffect(() => {
    usageService
      .getEgresoUsage()
      .then((u) => setEgresoUsage(u))
      .catch(() => {}); // fail-soft: sin dato, el 402 del backend cubre
  }, []);

  // Si el cupo está lleno, corta ANTES de abrir el modal de confirmación.
  const blockIfLimitReached = () => {
    if (egresoUsage?.status === "blocked") {
      setLimitModal({
        plan: egresoUsage.plan,
        limit: egresoUsage.limit,
        used: egresoUsage.used,
      });
      return true;
    }
    return false;
  };
  const [bulkAcceptMode, setBulkAcceptMode] = useState(false);

  // Sin filtro de fecha por default: se muestran todos los egresos (paginados).
  // El rango se aplica desde "Más filtros" cuando el usuario lo elige.
  const [filters, setFilters] = useState({
    type: "out",
  });

  const [paginacion, setPaginacion] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });

  const statusOptions = {
    pending: "Pendiente",
    in_progress: "En proceso",
    prepared: "Preparado",
    done: "Despachado",
    cancelled: "Cancelado",
  };

  const fetchAllEgresos = async (page, page_size) => {
    setBuscandoEgresos(true);
    try {
      const result = await egressService.getAllEgress({
        ...filters,
        page,
        pageSize: page_size,
      });

      const { results, paging, status_counts } = result.data;

      // Guardo: el backend devuelve `results: null` cuando un filtro no matchea nada.
      // Sin esto, results.sort() rompía la lista al filtrar a 0 resultados.
      const sortedResults = (results || []).sort(
        (a, b) => new Date(saleDate(b)) - new Date(saleDate(a))
      );

      setListadoDeEgresos(sortedResults);
      setStatusCounts(status_counts || {});
      setPaginacion({
        page: paging.page,
        pageSize: paging.page_size,
        total: paging.total,
      });
      setBuscandoEgresos(false);
    } catch (error) {
      setListadoDeEgresos([]);
      setBuscandoEgresos(false);
    }
  };

  useEffect(() => {
    fetchAllEgresos(paginacion.page, paginacion.pageSize);
  }, [filters]);

  useEffect(() => {
    const uid = sessionStorage.getItem("User");
    if (uid) {
      warehouseService.getScanOnPrepare(uid).then(setScanOnPrepare);
      warehouseService.getAutoPrintOnConfirm(uid).then(setAutoPrintOnConfirm);
    }
  }, []);

  // Buscador con debounce: espera 400ms sin tipear antes de filtrar (no dispara en
  // cada tecla). Se salta el primer render para no gatillar un fetch extra al montar.
  useEffect(() => {
    if (searchFirstRender.current) {
      searchFirstRender.current = false;
      return;
    }
    const t = setTimeout(() => {
      setPaginacion((prev) => ({ ...prev, page: 1 }));
      setFilters((f) => {
        const { q, ...rest } = f;
        const term = searchText.trim();
        return term ? { ...rest, q: term } : rest;
      });
    }, 400);
    return () => clearTimeout(t);
  }, [searchText]);

  // "Refresh ventas": busca ventas nuevas en las integraciones conectadas y recarga.
  const handleRefreshSales = async () => {
    setRefreshingSales(true);
    try {
      const resp = await egressService.RefreshSales();
      const imported = resp?.data?.imported ?? 0;
      setAlertObj({
        severity: "success",
        message:
          imported > 0
            ? `Se importaron ${imported} venta(s). Pueden tardar unos segundos en aparecer.`
            : "Sin ventas nuevas en las integraciones.",
      });
      setOpenSnack(true);
      // Damos unos segundos para que la cola procese y luego recargamos.
      setTimeout(() => fetchAllEgresos(paginacion.page, paginacion.pageSize), 3000);
    } catch (error) {
      setAlertObj({
        severity: "error",
        message: "No se pudieron buscar las ventas. Probá de nuevo.",
      });
      setOpenSnack(true);
    } finally {
      setRefreshingSales(false);
    }
  };

  const handleOpenDetailModal = async (id, isConfirm) => {
    setOpenBackdrop(true);

    const result = await ingressService.getIngressById(id);

    setIngressDetail(result.data);
    setOpenBackdrop(false);

    setModalView(true);
  };

  const handleCloseModalView = () => {
    setModalView(false);
  };

  const handleOpenDialog = (egress) => {
    if (blockIfLimitReached()) return; // cupo lleno: cartel directo, sin confirmación
    setBulkAcceptMode(false);
    setIngressDetail(egress);
    setModalPending(true);
  };
  const handleCloseDialog = () => {
    setModalPending(false);
    setBulkAcceptMode(false);
  };

  const isSameEgressId = (a, b) => normalizeEgressId(a) === normalizeEgressId(b);

  const togglePendingSelection = (id) => {
    setSelectedPendingIds((prev) =>
      prev.some((item) => isSameEgressId(item, id))
        ? prev.filter((item) => !isSameEgressId(item, id))
        : [...prev, id]
    );
  };

  const handleOpenBulkDialog = () => {
    if (!selectedPendingIds.length) return;
    if (blockIfLimitReached()) return; // cupo lleno: cartel directo, sin confirmación
    setBulkAcceptMode(true);
    setModalPending(true);
  };

  const handleOpenModalDone = async (egress) => {
    setMovementDetails(egress.movement_details);
    setIngressDetail(egress);
    // red_despacho: los bultos se cargaron en la creación (la fila del listado no trae
    // sus medidas). Traemos el detalle para re-enviarlos al confirmar "prepared" y que
    // el update no los borre (deletePackages + re-insert).
    const sm = egress?.shipping_method || egress?.logistics?.shippingMethod;
    if (sm === "red_despacho") {
      try {
        const result = await ingressService.getIngressById(egress.id);
        setPreparePackages(Array.isArray(result.data?.packages) ? result.data.packages : []);
      } catch (e) {
        console.error("No se pudieron cargar los bultos del egreso:", e);
        setPreparePackages([]);
      }
    } else {
      setPreparePackages([]);
    }
    setModalDone(true);
  };

  const handleCloseDone = () => {
    setModalDone(false);
  };

  const handleOpenDispatched = (egress) => {
    setIngressDetail(egress);
    setModalDispatched(true);
  };

  const handleCloseDispatched = () => {
    setModalDispatched(false);
  };

  const handleOpenCancelEgress = (id) => {
    setSelectedEgressIdForCancel(id);
    setOpenCancelModal(true);
  };

  const handleCloseCancelModal = () => {
    if (cancelingEgress) return;
    setOpenCancelModal(false);
    setSelectedEgressIdForCancel(null);
  };

  const handleConfirmCancelEgress = async () => {
    if (selectedEgressIdForCancel == null) return;
    setCancelingEgress(true);
    try {
      await egressService.cancelMovement(selectedEgressIdForCancel);
      setAlertObj({
        severity: "success",
        message: "Egreso cancelado exitosamente",
      });
      setOpenSnack(true);
      fetchAllEgresos(paginacion.page, paginacion.pageSize);
      setOpenCancelModal(false);
      setSelectedEgressIdForCancel(null);
    } catch (error) {
      setAlertObj({
        severity: "error",
        message: "Error al cancelar el egreso",
      });
      setOpenSnack(true);
    } finally {
      setCancelingEgress(false);
    }
  };

  const buildIngressPayload = (egress, status) => ({
    id: egress.id,
    type: egress.type,
    status,
    sub_movement_id: egress.sub_movement_id,
    receipt_id: egress.receipt_id,
    provider_name: egress.provider_name,
    warehouse_id: egress.warehouse_id,
    warehouse_name: egress.warehouse_name,
    email: egress.email,
    observation: egress.observation,
    phone_number: egress.phone_number,
    user_id: egress.user_id,
    movement_details: egress.movement_details.map((detalle) => ({
      product_id: detalle.product_id,
      description: detalle.description,
      original_count: detalle.original_count,
      effective_count:
        status === "prepared" ? detalle.original_count : detalle.effective_count,
    })),
    package_count: egress.package_count,
    packages: Array.isArray(egress.packages) ? egress.packages : [],
  });

  const acceptPendingEgress = async (egress) => {
    await ingressService.postRegisterIngress(
      buildIngressPayload(egress, "in_progress")
    );
  };

  const loadEgressDetailsForPdf = async (egresses) =>
    Promise.all(
      egresses.map(async (egress) => {
        try {
          const result = await ingressService.getIngressById(egress.id);
          return result.data;
        } catch (error) {
          console.error(`Error al cargar egreso ${egress.id} para PDF:`, error);
          return snapshotEgress(egress);
        }
      })
    );

  const handleConfirm = async (status, egress = ingressDetail) => {
    setLoading(true);

    try {
      if (status === "in_progress") {
        await acceptPendingEgress(egress);
      } else {
        await ingressService.postRegisterIngress(buildIngressPayload(egress, status));
      }

      // Cliente retira ML (no_shipping): al despachar/entregar, avisar la entrega a ML
      // (tag delivered a nivel orden; no hay shipment). Best-effort: si falla, no rompe
      // el flujo del WMS (el egreso igual queda despachado).
      if (
        status === "done" &&
        isMercadoLibreIntegration(egress) &&
        egress?.integration?.transaction_id &&
        (egress.shipping_method === "cliente" || egress.logistics?.shippingMethod === "cliente")
      ) {
        try {
          await integrationService.notifyMercadoLibreDelivered(egress.integration.transaction_id);
        } catch (e) {
          console.error("No se pudo avisar la entrega a ML:", e);
        }
      }

      const successMessage =
        status === "in_progress"
          ? "Pedido aceptado exitosamente."
          : status === "prepared"
            ? "Pedido preparado exitosamente."
            : status === "done"
              ? "Pedido despachado exitosamente."
              : "Operación realizada exitosamente.";

      setAlertObj({
        severity: "success",
        message: successMessage,
      });
      setOpenSnack(true);
      if (status === "in_progress") {
        await generatePDF(egress);
        handleCloseDialog();
      } else if (status === "prepared") {
        // Etiqueta de bulto al confirmar (directa vía QZ o descarga PDF, según el
        // formato del perfil): solo si la empresa activó la auto-impresión. Si está
        // off, se saca manual desde el listado ("Etiqueta de bulto").
        if (autoPrintOnConfirm) {
          await printBultoLabels(egress);
        }
        handleCloseDone();
      }
      handleCloseDispatched();
      fetchAllEgresos(paginacion.page, paginacion.pageSize);
      setLoading(false);
    } catch (error) {
      const errData = error?.response?.data;
      if (error?.response?.status === 402 && errData?.code === "egress_limit_reached") {
        // Cupo del plan lleno: cartel de upgrade en vez del toast genérico.
        setLimitModal({ plan: errData.plan, limit: errData.limit, used: errData.used });
      } else {
        setAlertObj({
          severity: "error",
          message: "Error al realizar la operación.",
        });
        setOpenSnack(true);
      }
      setLoading(false);
      if (status === "in_progress") {
        handleCloseDialog();
      } else if (status === "prepared") {
        handleCloseDone();
      }
      handleCloseDispatched();
    }
  };

  const handleBulkAccept = async () => {
    const selectedEgresses = listadoDeEgresos.filter(
      (egress) =>
        egress.status === "pending" &&
        !needsOperativa(egress) && // defensivo: sin operativa el backend lo rechaza
        selectedPendingIds.some(
          (id) => normalizeEgressId(id) === normalizeEgressId(egress.id)
        )
    );

    if (!selectedEgresses.length) {
      setAlertObj({
        severity: "warning",
        message: "No hay pedidos pendientes seleccionados.",
      });
      setOpenSnack(true);
      handleCloseDialog();
      return;
    }

    setLoading(true);
    let successCount = 0;
    let failedCount = 0;
    const acceptedEgresses = [];

    for (const egress of selectedEgresses) {
      const egressSnapshot = snapshotEgress(egress);
      try {
        await acceptPendingEgress(egressSnapshot);
        acceptedEgresses.push(egressSnapshot);
        successCount += 1;
      } catch (error) {
        const errData = error?.response?.data;
        if (error?.response?.status === 402 && errData?.code === "egress_limit_reached") {
          // Cupo lleno: cortar el lote y mostrar el cartel de upgrade.
          setLimitModal({ plan: errData.plan, limit: errData.limit, used: errData.used });
          break;
        }
        failedCount += 1;
      }
    }

    if (acceptedEgresses.length) {
      try {
        const pdfDetails = await loadEgressDetailsForPdf(acceptedEgresses);
        await generatePDF(pdfDetails);
      } catch (error) {
        console.error("Error generando PDF masivo:", error);
      }
    }

    setSelectedPendingIds([]);
    setBulkAcceptMode(false);
    handleCloseDialog();
    fetchAllEgresos(paginacion.page, paginacion.pageSize);
    setLoading(false);

    if (successCount && !failedCount) {
      setAlertObj({
        severity: "success",
        message: `${successCount} pedido${successCount === 1 ? "" : "s"} aceptado${successCount === 1 ? "" : "s"} exitosamente.`,
      });
    } else if (successCount && failedCount) {
      setAlertObj({
        severity: "warning",
        message: `${successCount} pedido(s) aceptado(s). ${failedCount} no se pudieron aceptar.`,
      });
    } else {
      setAlertObj({
        severity: "error",
        message: "No se pudieron aceptar los pedidos seleccionados.",
      });
    }
    setOpenSnack(true);
  };

  const generatePDF = async (detailsInput = ingressDetail) => {
    const details = Array.isArray(detailsInput)
      ? detailsInput.filter(Boolean)
      : [detailsInput].filter(Boolean);

    if (!details.length) return;

    try {
      const optimizedLogo = await optimizeImage(LogoPdf, {
        maxWidth: 300,
        maxHeight: 240,
        quality: 0.8,
      });

      const doc = new jsPDF();
      const isBulk = details.length > 1;

      if (isBulk) {
        renderBulkSummaryPage(doc, optimizedLogo, details);
      }

      for (let index = 0; index < details.length; index++) {
        const detail = details[index];

        if (isBulk) {
          doc.addPage();
          doc.setPage(index + 2);
        } else if (index > 0) {
          doc.addPage();
          doc.setPage(index + 1);
        }

        const logistics = parseLogistics(detail?.logistics);
        const deliveryDetails =
          logistics?.deliveryDetails || logistics?.delivery_details || {};

        let verticalSpace = renderEgressPdfHeader(
          doc,
          optimizedLogo,
          undefined,
          detail
        );

        doc.setFontSize(10);
        doc.setFont("Helvetica", "bold");
        doc.text("Información del egreso", 20, verticalSpace);

        doc.setFont("Helvetica", "normal");
        verticalSpace += 8;

        const currentDate = new Date().toLocaleDateString();
        doc.text(`Fecha de Creación: ${currentDate}`, 20, verticalSpace);
        doc.text(`Id Orden: ${detail.id}`, 110, verticalSpace);

        verticalSpace += 5;
        const clientName =
          detail.provider_name || deliveryDetails?.receiverName || "-";
        const clientPhone =
          detail.phone_number || deliveryDetails?.contact?.phone || "-";
        const clientDni = deliveryDetails?.receiverId || "";
        const shippingMethod = logistics?.shippingMethod || null;

        doc.text(`Cliente: ${clientName}`, 20, verticalSpace);
        doc.text(`Teléfono: ${clientPhone}`, 110, verticalSpace);

        verticalSpace += 5;
        if (clientDni) {
          doc.text(`DNI: ${clientDni}`, 20, verticalSpace);
        }
        if (shippingMethod) {
          doc.text(
            `Tipo de retiro: ${formatShippingMethod(shippingMethod)}`,
            110,
            verticalSpace
          );
        }
        if (!clientDni && !shippingMethod) {
          verticalSpace -= 5;
        }

        verticalSpace += 5;
        doc.text(`Depósito: ${detail.warehouse_name || detail.warehouse_id || "-"}`, 20, verticalSpace);

        verticalSpace += 5;
        if (deliveryDetails?.address?.street) {
          const addrLine = `${deliveryDetails.address.street}${
            deliveryDetails.address.streetNumber
              ? ` ${deliveryDetails.address.streetNumber}`
              : ""
          }${deliveryDetails.address.floor ? `, ${deliveryDetails.address.floor}` : ""}`;
          doc.text(`Dirección: ${addrLine}`, 20, verticalSpace);
          verticalSpace += 5;
        }
        if (deliveryDetails?.address?.city) {
          const cityLine = `${deliveryDetails.address.city}${
            deliveryDetails.address.zipCode
              ? ` (CP: ${deliveryDetails.address.zipCode})`
              : ""
          }`;
          doc.text(`Localidad: ${cityLine}`, 20, verticalSpace);
          verticalSpace += 5;
        }

        const totalBultos =
          (typeof detail?.package_count === "number" &&
            detail.package_count > 0 &&
            detail.package_count) ||
          (typeof detail?.bultos === "number" &&
            detail.bultos > 0 &&
            detail.bultos) ||
          (detail?.packages?.length || 0);
        doc.text(`Cantidad de bultos: ${totalBultos}`, 20, verticalSpace);

        verticalSpace += 5;

        doc.text(`Email: ${detail.email}`, 20, verticalSpace);

        verticalSpace += 6;
        doc.line(15, verticalSpace, 195, verticalSpace);

        verticalSpace += 10;
        const data = detail?.movement_details?.map((product) => [
          product.sku_id,
          product.description,
          product.original_count,
        ]);

        autoTable(doc, {
          startY: verticalSpace,
          head: [["SKU", "Descripción", "Cantidad"]],
          body: data,
          columnStyles: {
            0: { cellWidth: 40 },
            1: { cellWidth: 115 },
            2: { cellWidth: 25 },
          },
          styles: {
            overflow: "linebreak",
            halign: "center",
            valign: "middle",
            fontSize: 10,
            cellPadding: 3,
          },
        });

        verticalSpace = doc.lastAutoTable.finalY + 10;
        const totalUnidadesIngresadas = detail?.movement_details?.reduce(
          (total, producto) => total + (producto.original_count || 0),
          0
        );

        doc.setFont("Helvetica", "bold");
        doc.text(
          `Total de productos: ${detail?.movement_details?.length || 0}`,
          20,
          verticalSpace
        );
        verticalSpace += 5;
        doc.text(
          `Total de unidades: ${totalUnidadesIngresadas}`,
          20,
          verticalSpace
        );

        verticalSpace += 10;
        const pdfShippingMethod = logistics?.shippingMethod || null;

        if (
          pdfShippingMethod === "red_despacho" &&
          detail?.packages &&
          detail.packages.length > 0
        ) {
          verticalSpace += 10;
          doc.line(15, verticalSpace, 195, verticalSpace);
          verticalSpace += 8;
          doc.setFont("Helvetica", "bold");
          doc.text("Información de Bultos", 20, verticalSpace);
          doc.setFont("Helvetica", "normal");
          verticalSpace += 8;

          const packagesData = detail.packages.map((pkg, idx) => [
            pkg.index || idx + 1,
            `${pkg.width || "-"} x ${pkg.height || "-"} x ${pkg.depth || "-"} cm`,
            `${pkg.total_weight || "-"} g`,
            `$${pkg.declared_value || "-"}`,
          ]);

          autoTable(doc, {
            startY: verticalSpace,
            head: [["Bulto", "Dimensiones", "Peso", "Valor Declarado"]],
            body: packagesData,
            columnStyles: {
              0: { cellWidth: 25 },
              1: { cellWidth: 60 },
              2: { cellWidth: 40 },
              3: { cellWidth: 45 },
            },
            styles: {
              overflow: "linebreak",
              halign: "center",
              valign: "middle",
              fontSize: 9,
              cellPadding: 2,
            },
          });
        }

        let sectionY =
          detail?.packages?.length > 0
            ? doc.lastAutoTable.finalY + 12
            : verticalSpace + 5;

        const ensurePageForSection = (minY) => {
          if (minY > 250) {
            doc.addPage();
            return 20;
          }
          return minY;
        };

        const hasRedespachoTransport =
          deliveryDetails?.thirdPartyCarrier &&
          (deliveryDetails.thirdPartyCarrier.intermediate?.companyName ||
            deliveryDetails.thirdPartyCarrier.final?.companyName);

        if (pdfShippingMethod === "redespacho" && hasRedespachoTransport) {
          const carrier = deliveryDetails.thirdPartyCarrier;
          sectionY = ensurePageForSection(sectionY);
          doc.line(15, sectionY - 4, 195, sectionY - 4);
          doc.setFont("Helvetica", "bold");
          doc.text("Información de Transporte", 20, sectionY);
          doc.setFont("Helvetica", "normal");
          sectionY += 8;

          if (carrier.intermediate?.companyName) {
            doc.setFont("Helvetica", "bold");
            doc.text("Transporte Intermedio", 20, sectionY);
            sectionY += 6;
            doc.setFont("Helvetica", "normal");
            doc.text(`Empresa: ${carrier.intermediate.companyName}`, 20, sectionY);
            sectionY += 5;
            if (carrier.intermediate.licensePlate) {
              doc.text(`Patente: ${carrier.intermediate.licensePlate}`, 20, sectionY);
              sectionY += 5;
            }
            if (carrier.intermediate.phone) {
              doc.text(`Tel: ${carrier.intermediate.phone}`, 20, sectionY);
              sectionY += 5;
            }
            sectionY += 4;
          }

          if (carrier.final?.companyName) {
            sectionY = ensurePageForSection(sectionY);
            doc.setFont("Helvetica", "bold");
            doc.text("Transporte Final", 20, sectionY);
            sectionY += 6;
            doc.setFont("Helvetica", "normal");
            doc.text(`Empresa: ${carrier.final.companyName}`, 20, sectionY);
            sectionY += 5;
            if (carrier.final.licensePlate) {
              doc.text(`Patente: ${carrier.final.licensePlate}`, 20, sectionY);
              sectionY += 5;
            }
            if (carrier.final.phone) {
              doc.text(`Tel: ${carrier.final.phone}`, 20, sectionY);
              sectionY += 5;
            }
          }
        }

        if (pdfShippingMethod === "red_despacho" && deliveryDetails?.quote?.carrierName) {
          const q = deliveryDetails.quote;
          sectionY = ensurePageForSection(sectionY);
          doc.line(15, sectionY - 4, 195, sectionY - 4);
          doc.setFont("Helvetica", "bold");
          doc.text("Cotización de Envío", 20, sectionY);
          sectionY += 6;
          doc.setFont("Helvetica", "normal");
          doc.text(`Transportista: ${q.carrierName}`, 20, sectionY);
          sectionY += 5;
          if (q.price != null && q.price !== "") {
            doc.text(`Precio: $${Number(q.price).toLocaleString()}`, 20, sectionY);
            sectionY += 5;
          }
          if (q.estimatedDays != null && q.estimatedDays !== "") {
            doc.text(`Tiempo estimado: ${q.estimatedDays} días`, 20, sectionY);
          }
        }
      }

      const fileName =
        details.length === 1
          ? `Detalle_Egreso_${details[0].id || "sin_id"}.pdf`
          : `Detalle_Egresos_${details.map((item) => item.id).join("-")}.pdf`;

      doc.save(fileName);
    } catch (error) {
      console.error("Error generando el PDF:", error);
      setAlertObj({
        severity: "error",
        message: "Error al generar el PDF",
      });
      setOpenSnack(true);
    }
  };

  const optimizeImage = (imageSource, options = {}) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");

        let width = img.width;
        let height = img.height;

        if (options.maxWidth && width > options.maxWidth) {
          height = (options.maxWidth * height) / width;
          width = options.maxWidth;
        }

        if (options.maxHeight && height > options.maxHeight) {
          width = (options.maxHeight * width) / height;
          height = options.maxHeight;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        resolve(canvas.toDataURL("image/png", options.quality || 0.8));
      };
      img.src = imageSource;
    });
  };

  const getColumns = () => {
    // Procesar (preparar/despachar/aceptar) = update; Cancelar = delete (destructiva).
    const hasUpdatePermission = AuthService.hasPermission(
      "update",
      "movement_out"
    );
    const hasReadPermission = AuthService.hasPermission("read", "movement_out");
    const hasDeletePermission = AuthService.hasPermission(
      "delete",
      "movement_out"
    );
    const canAccept = hasUpdatePermission;
    // Solo los "listos para preparar" (pendiente + operativa): igual que el check por fila.
    const pendingOnPage = listadoDeEgresos.filter(
      (row) => row.status === "pending" && !needsOperativa(row)
    );
    const allPendingSelected =
      pendingOnPage.length > 0 &&
      pendingOnPage.every((row) =>
        selectedPendingIds.some((id) => isSameEgressId(id, row.id))
      );
    const somePendingSelected = pendingOnPage.some((row) =>
      selectedPendingIds.some((id) => isSameEgressId(id, row.id))
    );

    const handleToggleSelectAllPending = () => {
      if (allPendingSelected) {
        const pendingIds = pendingOnPage.map((row) => row.id);
        setSelectedPendingIds((prev) =>
          prev.filter(
            (id) => !pendingIds.some((pendingId) => isSameEgressId(id, pendingId))
          )
        );
      } else {
        const pendingIds = pendingOnPage.map((row) => row.id);
        setSelectedPendingIds((prev) => [...new Set([...prev, ...pendingIds])]);
      }
    };

    return [
      ...(canAccept
        ? [
            {
              title: (
                <Checkbox
                  size="small"
                  checked={allPendingSelected}
                  indeterminate={somePendingSelected && !allPendingSelected}
                  onChange={handleToggleSelectAllPending}
                  disabled={pendingOnPage.length === 0}
                  inputProps={{ "aria-label": "Seleccionar pedidos pendientes" }}
                  sx={{ p: 0 }}
                />
              ),
              field: "select",
              sorting: false,
              width: 44,
              minWidth: 44,
              maxWidth: 44,
              padding: "4px 6px",
              verticalPadding: "4px",
              render: (rowData) =>
                rowData.status === "pending" && !needsOperativa(rowData) ? (
                  <Checkbox
                    size="small"
                    checked={selectedPendingIds.some((id) =>
                      isSameEgressId(id, rowData.id)
                    )}
                    onChange={() => togglePendingSelection(rowData.id)}
                    inputProps={{
                      "aria-label": `Seleccionar pedido ${rowData.id}`,
                    }}
                    sx={{ p: 0 }}
                  />
                ) : null,
            },
          ]
        : []),
      {
        title: "Fecha de Creacion",
        field: "date_created",
        sorting: false,
        minWidth: 150,
        render: (rowData) => {
          const fullDate = formatDateString(saleDate(rowData));
          const [date, time] = fullDate.split(" ");

          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span>{date}</span>
              <span style={{ fontSize: "0.75em", color: "#666" }}>{time}</span>
            </div>
          );
        },
      },
      {
        title: "N° Orden",
        field: "id",
        maxWidth: 100,
        sorting: false,
        render: (rowData) => (
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "#2563EB", fontSize: "0.85rem" }}
          >
            #{rowData.id}
          </Typography>
        ),
      },
      {
        title: "ID Integración",
        sorting: false,
        render: (rowData) => (
          <Typography variant="body2" sx={{ color: rowData.integration?.transaction_id ? "text.primary" : "#999", fontSize: "0.85rem" }}>
            {formatSaleRef(rowData.integration)}
          </Typography>
        ),
      },
      {
        title: "Canal",
        sorting: false,
        render: (rowData) => (
          <Typography variant="body2" sx={{ color: rowData.integration ? "text.primary" : "#999", fontSize: "0.85rem" }}>
            {rowData.integration ? formatPlatformName(rowData.integration.name) : "—"}
          </Typography>
        ),
      },
      {
        title: "Operativa",
        field: "operativa",
        sorting: false,
        maxWidth: 110,
        render: (row) => {
          const m = row.shipping_method;
          if (needsOperativa(row)) {
            return (
              <Typography variant="body2" sx={{ color: "#e65100", fontSize: "0.8rem", fontWeight: 600, textAlign: "center" }}>
                ⚠ Sin asignar
              </Typography>
            );
          }
          if (isMlShippingMode(m)) {
            return (
              <Chip
                label={ML_SHIPPING_MODES[String(m).toLowerCase()]}
                size="small"
                sx={{ backgroundColor: "#FFF3C4", color: "#8a6d00", fontWeight: 600, fontSize: "0.72rem", borderRadius: "6px" }}
              />
            );
          }
          const map = {
            cliente: "Cliente retira",
            retiro_puerta: "Cliente retira",
            red_despacho: "Despacho",
            redespacho: "Redespacho",
            transporte_manual: "Transporte retira",
          };
          const label = m ? map[String(m).toLowerCase()] || String(m).replace(/_/g, " ") : "—";
          return (
            <Typography variant="body2" sx={{ color: "#555", fontSize: "0.85rem", textAlign: "center" }}>
              {label}
            </Typography>
          );
        },
      },
      {
        title: "Cliente",
        field: "provider_name",
        sorting: false,
        maxWidth: 120,
        render: (row) => (
          <Typography variant="body2" sx={{ fontWeight: 500, textAlign: "center" }}>
            {row.provider_name}
          </Typography>
        ),
      },
      {
        title: "Estado",
        sorting: false,
        field: "status",
        maxWidth: 130,
        render: (rowData) => {
          const statusColors = {
            pending: { bg: "#fff3e0", color: "#e65100", label: "Pendiente" },
            in_progress: { bg: "#E8F0FE", color: "#2563EB", label: "En proceso" },
            prepared: { bg: "#f3e5f5", color: "#7b1fa2", label: "Preparado" },
            done: { bg: "#e8f5e9", color: "#2e7d32", label: "Despachado" },
            cancelled: { bg: "#ffebee", color: "#c62828", label: "Cancelado" },
          };
          const s = statusColors[rowData.status] || { bg: "#f5f5f5", color: "#616161", label: rowData.status };
          return (
            <Chip
              label={s.label}
              size="small"
              sx={{
                backgroundColor: s.bg,
                color: s.color,
                fontWeight: 600,
                fontSize: "0.75rem",
                borderRadius: "6px",
              }}
            />
          );
        },
      },
      {
        title: "Acciones",
        field: "acciones",
        sorting: false,
        render: (rowData) => (
          <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
            {hasUpdatePermission && (
              <>
                {rowData.status === "pending" && needsOperativa(rowData) && (
                  <Tooltip title="Asignar operativa" arrow>
                    <Box
                      component="span"
                      onClick={() => navigate(`/create-egress?completar=${rowData.id}`)}
                      sx={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "8px",
                        transition: "background-color 0.2s",
                        "&:hover": { backgroundColor: "#FFF1E8" },
                      }}
                    >
                      <LocalShippingOutlinedIcon sx={{ fontSize: 20, color: "#F2651A" }} />
                    </Box>
                  </Tooltip>
                )}
                {rowData.status === "pending" && !needsOperativa(rowData) && (
                  <Tooltip title="Preparar pedido" arrow>
                    <Box
                      component="span"
                      onClick={() => handleOpenDialog(rowData)}
                      sx={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "8px",
                        transition: "background-color 0.2s",
                        "&:hover": { backgroundColor: "#E8F0FE" },
                      }}
                    >
                      <ReceiptLongIcon sx={{ fontSize: 20, color: "#2563EB" }} />
                    </Box>
                  </Tooltip>
                )}
                {rowData.status === "in_progress" && (
                  <Tooltip title="Marcar como preparado" arrow>
                    <Box
                      component="span"
                      onClick={() => handleOpenModalDone(rowData)}
                      sx={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "8px",
                        transition: "background-color 0.2s",
                        "&:hover": { backgroundColor: "#f3e5f5" },
                      }}
                    >
                      <ContentPasteGoIcon sx={{ fontSize: 20, color: "#7b1fa2" }} />
                    </Box>
                  </Tooltip>
                )}
                {rowData.status === "prepared" && (
                  <Tooltip title="Marcar como despachado" arrow>
                    <Box
                      component="span"
                      onClick={() => handleOpenDispatched(rowData)}
                      sx={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "8px",
                        transition: "background-color 0.2s",
                        "&:hover": { backgroundColor: "#e8f5e9" },
                      }}
                    >
                      <LocalShippingIcon sx={{ fontSize: 20, color: "#2e7d32" }} />
                    </Box>
                  </Tooltip>
                )}
              </>
            )}
            {hasReadPermission && (
              <Tooltip title="Ver detalle" arrow>
                <Box
                  component="span"
                  onClick={() => handleOpenDetailModal(rowData.id, false)}
                  sx={{
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    transition: "background-color 0.2s",
                    "&:hover": { backgroundColor: "#E8F0FE" },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: 20, color: "#2563EB" }} />
                </Box>
              </Tooltip>
            )}
            {(() => {
              const ml = isMercadoLibreIntegration(rowData);
              // ME2/Flex tienen etiqueta ML; se baja on-demand al imprimir (no hay ticket
              // pre-guardado). Cliente-retira/ME1 no tienen etiqueta ML.
              const mlLabeled = isMlShippingMode(rowData.shipping_method);
              return (
                <>
                  {ml && mlLabeled && (rowData.status === "prepared" || rowData.status === "done") && !rowData.label_printed_at && (
                    <Tooltip title="Imprimir etiqueta (Mercado Libre)" arrow>
                      <Box
                        component="span"
                        onClick={() => handleDownloadMercadoLibreLabel(rowData)}
                        sx={{
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 32,
                          height: 32,
                          borderRadius: "8px",
                          transition: "background-color 0.2s",
                          "&:hover": { backgroundColor: "#fff3e0" },
                        }}
                      >
                        <PrintIcon sx={{ fontSize: 20, color: "#e65100" }} />
                      </Box>
                    </Tooltip>
                  )}
                </>
              );
            })()}
            {hasDeletePermission && rowData.status === "pending" && (
                <Tooltip title="Cancelar egreso" arrow>
                  <Box
                    component="span"
                    onClick={() => handleOpenCancelEgress(rowData.id)}
                    sx={{
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 32,
                      height: 32,
                      borderRadius: "8px",
                      transition: "background-color 0.2s",
                      "&:hover": { backgroundColor: "#ffebee" },
                    }}
                  >
                    <CancelIcon sx={{ fontSize: 20, color: "#c62828" }} />
                  </Box>
                </Tooltip>
              )}
          </Box>
        ),
      },
    ];
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const handleOpenFilterModal = (event) => setAnchorEl(event.currentTarget);
  const handleCloseFilterModal = () => setAnchorEl(null);
  const renderEgressCard = (rowData) => {
    const hasUpdatePermission = AuthService.hasPermission("update", "movement_out");
    const hasReadPermission = AuthService.hasPermission("read", "movement_out");
    const hasDeletePermission = AuthService.hasPermission("delete", "movement_out");
    const sinOperativa = needsOperativa(rowData);
    // El check de selección múltiple aparece SOLO donde está el botón "Preparar"
    // (pendiente + operativa asignada): son los únicos preparables en lote.
    const canSelect = hasUpdatePermission && rowData.status === "pending" && !sinOperativa;

    const dets = rowData.movement_details || [];
    const numProductos = dets.length;
    const numUnidades = dets.reduce((s, d) => s + Number(d.original_count || 0), 0);
    const [fecha, hora] = formatDateString(saleDate(rowData)).split(" ");

    const statusColors = {
      pending: { bg: "#fff8e1", color: "#e65100", label: "Pendiente" },
      in_progress: { bg: "#ede7f6", color: "#5e35b1", label: "En proceso" },
      prepared: { bg: "#e3f2fd", color: "#1565c0", label: "Preparado" },
      done: { bg: "#e8f5e9", color: "#2e7d32", label: "Despachado" },
      cancelled: { bg: "#ffebee", color: "#c62828", label: "Cancelado" },
    };
    const st = statusColors[rowData.status] || { bg: "#f5f5f5", color: "#616161", label: rowData.status };

    const operativaMap = {
      cliente: "Cliente retira",
      retiro_puerta: "Cliente retira",
      red_despacho: "Despacho",
      redespacho: "Redespacho",
      transporte_manual: "Transporte retira",
      me_flex: "MercadoEnvíos Flex",
      me2: "MercadoEnvíos (ME2)",
    };
    const operativaLabel = sinOperativa
      ? "⚠ Sin asignar"
      : rowData.shipping_method
        ? operativaMap[String(rowData.shipping_method).toLowerCase()] || String(rowData.shipping_method).replace(/_/g, " ")
        : "—";

    const ml = isMercadoLibreIntegration(rowData);
    // ME2/Flex tienen etiqueta ML (se baja on-demand al imprimir). ML1/cliente-retira no.
    const mlLabeled = isMlShippingMode(rowData.shipping_method);
    const isSelected = selectedPendingIds.some((id) => isSameEgressId(id, rowData.id));

    const actionButtons = (
      <>
        {hasReadPermission && (
          <Button size="small" variant="outlined" startIcon={<VisibilityIcon sx={{ fontSize: 17 }} />} onClick={() => handleOpenDetailModal(rowData.id, false)} sx={{ textTransform: "none", borderRadius: "8px", borderColor: "#cbd5e1", color: "#475569", py: 0.3 }}>
            Ver detalle
          </Button>
        )}
        {ml && mlLabeled && (rowData.status === "prepared" || rowData.status === "done") && !rowData.label_printed_at && (
          <Button size="small" variant="outlined" startIcon={<PrintIcon sx={{ fontSize: 17 }} />} onClick={() => handleDownloadMercadoLibreLabel(rowData)} sx={{ textTransform: "none", borderRadius: "8px", borderColor: "#ffcc80", color: "#e65100", py: 0.3 }}>
            Imprimir etiqueta
          </Button>
        )}
        {hasReadPermission && (rowData.status === "prepared" || rowData.status === "done") && !rowData.label_printed_at && (
          <Button size="small" variant="outlined" startIcon={<PrintIcon sx={{ fontSize: 17 }} />} onClick={() => printBultoLabels(rowData)} sx={{ textTransform: "none", borderRadius: "8px", borderColor: "#cbd5e1", color: "#475569", py: 0.3 }}>
            {rowData.shipping_method === "red_despacho" ? "Etiqueta de paquetería" : "Etiqueta de bulto"}
          </Button>
        )}
        {hasUpdatePermission && rowData.status === "pending" && sinOperativa && (
          <Button size="small" variant="contained" startIcon={<LocalShippingOutlinedIcon sx={{ fontSize: 17 }} />} onClick={() => navigate(`/create-egress?completar=${rowData.id}`)} sx={{ textTransform: "none", borderRadius: "8px", backgroundColor: "#F2651A", py: 0.3, "&:hover": { backgroundColor: "#d95513" } }}>
            Asignar operativa
          </Button>
        )}
        {hasUpdatePermission && rowData.status === "pending" && !sinOperativa && (
          <Button size="small" variant="contained" startIcon={<ReceiptLongIcon sx={{ fontSize: 17 }} />} onClick={() => handleOpenDialog(rowData)} sx={{ textTransform: "none", borderRadius: "8px", py: 0.3 }}>
            Preparar
          </Button>
        )}
        {hasUpdatePermission && rowData.status === "in_progress" && (
          <Button size="small" variant="contained" startIcon={<ContentPasteGoIcon sx={{ fontSize: 17 }} />} onClick={() => handleOpenModalDone(rowData)} sx={{ textTransform: "none", borderRadius: "8px", backgroundColor: "#7b1fa2", py: 0.3, "&:hover": { backgroundColor: "#6a1b9a" } }}>
            Marcar preparado
          </Button>
        )}
        {hasUpdatePermission && rowData.status === "prepared" && (
          <Button size="small" variant="contained" startIcon={<LocalShippingIcon sx={{ fontSize: 17 }} />} onClick={() => handleOpenDispatched(rowData)} sx={{ textTransform: "none", borderRadius: "8px", backgroundColor: "#2e7d32", py: 0.3, "&:hover": { backgroundColor: "#1b5e20" } }}>
            Despachar
          </Button>
        )}
        {hasDeletePermission && rowData.status === "pending" && (
          <Button size="small" variant="outlined" startIcon={<CancelIcon sx={{ fontSize: 17 }} />} onClick={() => handleOpenCancelEgress(rowData.id)} sx={{ textTransform: "none", borderRadius: "8px", borderColor: "#fca5a5", color: "#dc2626", py: 0.3, "&:hover": { borderColor: "#ef4444", backgroundColor: "#fef2f2" } }}>
            Cancelar
          </Button>
        )}
      </>
    );

    return (
      <Paper
        key={rowData.id}
        elevation={0}
        sx={{ border: "1px solid #e2e8f0", borderRadius: "12px", px: 2, py: 1.25, mb: 1, transition: "box-shadow 0.2s", "&:hover": { boxShadow: "0 2px 10px rgba(0,0,0,0.07)" } }}
      >
        {/* Header en una línea */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 0.5, mb: 0.6 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, flexWrap: "wrap" }}>
            {canSelect && (
              <Checkbox size="small" checked={isSelected} onChange={() => togglePendingSelection(rowData.id)} sx={{ p: 0, mr: 0.3 }} inputProps={{ "aria-label": `Seleccionar pedido ${rowData.id}` }} />
            )}
            <Typography sx={{ fontWeight: 700, color: "#2563EB", fontSize: "0.9rem" }}>#{rowData.id}</Typography>
            <Typography variant="caption" sx={{ color: "#999" }}>· {fecha} {hora}</Typography>
            {rowData.integration && (
              <Chip label={formatPlatformName(rowData.integration.name)} size="small" sx={{ backgroundColor: "#FFF1E8", color: "#F2651A", fontWeight: 600, fontSize: "0.7rem", height: 20 }} />
            )}
            {rowData.integration?.transaction_id && (
              <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>{formatSaleRef(rowData.integration)}</Typography>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
            <Chip label={st.label} sx={{ backgroundColor: st.bg, color: st.color, fontWeight: 700, fontSize: "0.85rem", borderRadius: "8px", height: 30, px: 0.5 }} />
          </Box>
        </Box>

        {/* Cuerpo en 2 columnas */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2, flexWrap: "wrap" }}>
          <Box sx={{ flex: "1 1 160px", minWidth: 150 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{rowData.provider_name || "—"}</Typography>
            <Typography variant="caption" sx={{ color: "#555" }}>
              {numProductos} producto{numProductos === 1 ? "" : "s"} · {numUnidades} unidad{numUnidades === 1 ? "" : "es"}
              {rowData.package_count > 0 ? ` · ${rowData.package_count} bulto${rowData.package_count === 1 ? "" : "s"}` : ""}
            </Typography>
          </Box>

          <Box sx={{ flex: "1 1 220px", minWidth: 180 }}>
            <Typography variant="caption" sx={{ display: "block", color: sinOperativa ? "#e65100" : "#777", fontWeight: sinOperativa ? 600 : 400 }}>
              Operativa: {operativaLabel}
              {rowData.carrier_name ? (
                <Box component="span" sx={{ color: "#475569", fontWeight: 600 }}> — {rowData.carrier_name}</Box>
              ) : null}
            </Typography>
            {(rowData.delivery_city || rowData.delivery_zip || rowData.delivery_province) && (
              <Typography variant="caption" sx={{ display: "block", color: "#777" }}>
                📍 {[rowData.delivery_city, rowData.delivery_zip, rowData.delivery_province].filter(Boolean).join(" · ")}
              </Typography>
            )}
            {(() => {
              // Seguimiento vivo del envío del canal (ML): lo mantiene el webhook.
              const tk = channelTracking(rowData.channel_status, rowData.channel_substatus);
              if (!tk) return null;
              return (
                <Box sx={{ mt: 0.5, display: "flex", alignItems: "center", gap: 0.7, flexWrap: "wrap" }}>
                  <Box component="span" sx={{ backgroundColor: tk.bg, color: tk.color, borderRadius: "6px", px: 0.9, py: 0.2, fontSize: "0.72rem", fontWeight: 700 }}>
                    {tk.label}
                  </Box>
                  {rowData.tracking_code ? (
                    <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                      Track: {rowData.tracking_code}
                    </Typography>
                  ) : null}
                </Box>
              );
            })()}
          </Box>
        </Box>

        {/* Acciones debajo, separadas por una línea suave */}
        <Box sx={{ mt: 1, pt: 1, borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "flex-end", gap: 1, flexWrap: "wrap" }}>
          {actionButtons}
        </Box>
      </Paper>
    );
  };

  const handleFilterApply = (newFilters) => setFilters(newFilters);

  const handleIntegrationChange = (event, newValue) => {
    setSelectedIntegration(newValue);
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    setFilters({
      ...filters,
      integration_name: newValue?.value || undefined,
    });
  };

  const handleOperativaChange = (event, newValue) => {
    setSelectedOperativa(newValue);
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    setFilters((f) => {
      const { operativa, ...rest } = f;
      return newValue ? { ...rest, operativa: newValue.value } : rest;
    });
  };

  const handleProvinceChange = (event, newValue) => {
    setSelectedProvince(newValue);
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    setFilters((f) => {
      const { province, ...rest } = f;
      return newValue ? { ...rest, province: newValue } : rest;
    });
  };

  // Chips de filtros activos: quitar uno o limpiar todo.
  const clearCanalFilter = () => {
    setSelectedIntegration(null);
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    setFilters(({ integration_name, ...rest }) => rest);
  };

  const clearOperativaFilter = () => {
    setSelectedOperativa(null);
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    setFilters(({ operativa, ...rest }) => rest);
  };

  const clearProvinceFilter = () => {
    setSelectedProvince(null);
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    setFilters(({ province, ...rest }) => rest);
  };

  const clearSearchFilter = () => {
    setSearchText("");
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    setFilters(({ q, ...rest }) => rest);
  };

  const clearDateFilter = () => {
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    setFilters(({ from, to, ...rest }) => rest);
  };

  const clearAllFilters = () => {
    setSelectedIntegration(null);
    setSelectedOperativa(null);
    setSelectedProvince(null);
    setSearchText("");
    setPaginacion((prev) => ({ ...prev, page: 1 }));
    // Preserva la tab de estado (status); limpia solo los filtros de la barra.
    setFilters((f) => ({ type: "out", ...(f.status ? { status: f.status } : {}) }));
  };

  /** Solo Mercado Libre ME2/Flex: baja la etiqueta ON-DEMAND del canal. Recién en este
   *  momento ML marca el envío "impreso" (no se baja en el sync). */
  const handleDownloadMercadoLibreLabel = async (rowData) => {
    const orderId = rowData.integration?.transaction_id;
    if (!orderId) {
      setAlertObj({
        severity: "warning",
        message: "Este egreso no tiene una orden de Mercado Libre asociada",
      });
      setOpenSnack(true);
      return;
    }

    try {
      const blob = await integrationService.getMercadoLibreLabel(orderId);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `etiqueta_${orderId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      await markEgressLabelPrinted(rowData);
    } catch (error) {
      console.error("Error al descargar la etiqueta:", error);
      setAlertObj({
        severity: "error",
        message: "No se pudo obtener la etiqueta de Mercado Libre",
      });
      setOpenSnack(true);
    }
  };

  // Arma el array de etiquetas de bulto a partir del egreso ya cargado. Lo usan tanto
  // la impresión por PDF (legacy/manual) como la impresión ZPL nativa (QZ Tray).
  const buildBultoLabelsFromEgress = (egressData) => {
    const packages = Array.isArray(egressData.packages) ? egressData.packages : [];
    const pc = egressData.package_count;
    const totalBultos = typeof pc === "number" && pc > 0 ? pc : packages.length || 1;

    const logistics = parseLogistics(egressData.logistics);
    const deliveryDetails = logistics.deliveryDetails || logistics.delivery_details || {};
    const thirdPartyCarrier = thirdPartyCarrierFromLogistics(egressData.logistics);

    const orderId = egressData.id;
    const clientName = egressData.provider_name || "";
    const remitente = warehouseRemitenteOneLine(egressData);

    return Array.from({ length: totalBultos }, (_, index) => {
      const pkg = packages[index] ?? packages[0] ?? {};
      const movementDetail = egressData.movement_details?.[index] || egressData.movement_details?.[0] || {};
      const productName = movementDetail.description || "";
      const productSku = movementDetail.sku_id || movementDetail.product_id || "";

      return {
        index: pkg.index || index + 1,
        total: totalBultos,
        orderId,
        clientName,
        shippingMethod: logistics.shippingMethod || null,
        ...(thirdPartyCarrier ? { thirdPartyCarrier } : {}),
        destinatario: {
          nombre: deliveryDetails.receiverName || clientName,
          dni: deliveryDetails.receiverId || "",
          telefono: deliveryDetails.contact?.phone || egressData.phone_number || "",
          direccion: deliveryDetails.address?.street || "",
          localidad: deliveryDetails.address?.city || "",
          cp: deliveryDetails.address?.zipCode || "",
          email: deliveryDetails.contact?.email || egressData.email || "",
        },
        parentSku: productSku,
        displayName: productName,
        width: pkg.width || 0,
        height: pkg.height || 0,
        depth: pkg.depth || 0,
        total_weight: pkg.total_weight || 0,
        declared_value: pkg.declared_value || 0,
        barcode: `${orderId}-B${index + 1}`,
        remitente,
      };
    });
  };

  // Marca el egreso como "etiqueta impresa" (persistente en DB) y actualiza la fila en
  // memoria para ocultar el botón al instante. Best-effort: si el PUT falla, el próximo
  // fetch refleja el estado real (el botón reaparecería). Idempotente en el backend.
  const markEgressLabelPrinted = async (rowData) => {
    const id = rowData?.id;
    if (!id) return;
    setListadoDeEgresos((prev) =>
      prev.map((row) =>
        isSameEgressId(row.id, id)
          ? { ...row, label_printed_at: row.label_printed_at || new Date().toISOString() }
          : row
      )
    );
    try {
      await egressService.markLabelPrinted(id);
    } catch (e) {
      console.error("No se pudo persistir la impresión de la etiqueta:", e);
    }
  };

  // Envío convencional (red_despacho): la etiqueta de bulto se reemplaza por la etiqueta
  // de la PAQUETERÍA. Baja el PDF del carrier (que trae una etiqueta por bulto, porque el
  // envío se creó con los N bultos declarados en la creación). Si el envío todavía no se
  // generó (sin tracking), lo genera y luego baja la etiqueta.
  const printCarrierLabel = async (rowData) => {
    const logisticsId = rowData?.movement_logistics_id;
    if (!logisticsId) {
      setAlertObj({
        severity: "warning",
        message: "Este egreso no tiene logística asociada para imprimir la etiqueta de paquetería.",
      });
      setOpenSnack(true);
      return;
    }
    try {
      if (!rowData?.tracking_code) {
        // Generar el envío en la paquetería primero (devuelve tracking).
        await integrationService.createLogisticsShipment(logisticsId);
      }
      const blob = await integrationService.getLogisticsLabel(logisticsId);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `etiqueta_paqueteria_${rowData.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      await markEgressLabelPrinted(rowData);
    } catch (error) {
      console.error("Error al obtener la etiqueta de la paquetería:", error);
      setAlertObj({
        severity: "error",
        message: "No se pudo obtener la etiqueta de la paquetería. Verificá que el envío esté generado en el carrier.",
      });
      setOpenSnack(true);
    }
  };

  // Etiqueta de bulto (al confirmar el packing o a demanda desde el listado), según el
  // "Formato de etiqueta" configurado en el perfil de esta PC:
  //   - direct → ZPL/TSPL nativo vía QZ Tray en la impresora térmica configurada.
  //   - pdf    → genera y descarga el PDF de bultos (EgressLabelPrinter).
  // Si la impresión directa no puede hacerse (sin impresora, QZ caído, etc.) cae a la
  // descarga PDF: la etiqueta siempre tiene que salir.
  // red_despacho: se deriva a la etiqueta de la paquetería (reemplaza a la de bulto).
  const printBultoLabels = async (rowData) => {
    if (rowData?.shipping_method === "red_despacho") {
      return printCarrierLabel(rowData);
    }
    let egressData;
    try {
      const response = await ingressService.getIngressById(rowData.id);
      egressData = response.data;
    } catch (error) {
      console.error("Error al obtener datos del egreso:", error);
    }
    if (!egressData || typeof egressData !== "object" || !egressData.id) {
      setAlertObj({ severity: "warning", message: "No se pudo obtener el egreso para la etiqueta." });
      setOpenSnack(true);
      return;
    }
    const labels = buildBultoLabelsFromEgress(egressData);

    const cfg = getPrinterConfig();
    if (cfg.labelFormat !== "pdf") {
      if (cfg.printerName) {
        try {
          for (const label of labels) {
            const data = buildBultoLabel(label, {
              language: cfg.language,
              dpi: cfg.dpi,
              labelSize: cfg.labelSize,
            });
            await printZpl(cfg.printerName, data);
          }
          await markEgressLabelPrinted(rowData);
          return;
        } catch (error) {
          console.error("Error imprimiendo etiquetas ZPL/TSPL:", error);
          setAlertObj({
            severity: "warning",
            message:
              "No se pudo imprimir por QZ Tray (¿abierto y la impresora encendida?). Se descarga la etiqueta en PDF.",
          });
          setOpenSnack(true);
        }
      } else {
        setAlertObj({
          severity: "warning",
          message:
            "No hay impresora configurada en esta PC (Perfil → Impresora de etiquetas). Se descarga la etiqueta en PDF.",
        });
        setOpenSnack(true);
      }
    }

    setLabelsToPrint(labels);
    await markEgressLabelPrinted(rowData);
  };

  return (
    <>
      <Grid container padding={5}>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: "#1a1a1a",
              pl: 1.5,
              borderLeft: (theme) => `4px solid ${theme.palette.secondary.main}`,
              lineHeight: 1.5,
            }}
          >
            Todos los egresos
          </Typography>
          <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleRefreshSales}
              disabled={refreshingSales}
              startIcon={
                refreshingSales ? <CircularProgress size={16} color="inherit" /> : <SyncIcon />
              }
              sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 2.5 }}
            >
              {refreshingSales ? "Buscando…" : "Refresh ventas"}
            </Button>
            {hasCreatePermission && (
              <Link to="/create-egress" style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 3 }}
                >
                  Crear egreso
                </Button>
              </Link>
            )}
          </Box>
        </Box>

        <Paper
          elevation={0}
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1.5,
            p: 1.5,
            mb: 2,
            borderRadius: "10px",
            border: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
          }}
        >
          <TextField
            size="small"
            placeholder="Buscar: Nº, cliente, email, Nº orden…"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
              endAdornment: searchText ? (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={clearSearchFilter}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{ minWidth: 240, flex: 1, backgroundColor: "#fff" }}
          />
          <styles.StyledAutocomplete
            options={OPERATIVA_OPTIONS}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            renderInput={(params) => <TextField {...params} label="Operativa" />}
            value={selectedOperativa}
            onChange={handleOperativaChange}
          />
          <styles.StyledAutocomplete
            options={SALES_CHANNEL_OPTIONS}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            renderInput={(params) => (
              <TextField {...params} label="Canal de venta" />
            )}
            value={selectedIntegration}
            onChange={handleIntegrationChange}
          />
          <styles.StyledAutocomplete
            options={AR_PROVINCES}
            renderInput={(params) => <TextField {...params} label="Provincia" />}
            value={selectedProvince}
            onChange={handleProvinceChange}
          />
          <Tooltip title="Más filtros">
            <Button
              sx={{
                minWidth: "42px",
                width: "42px",
                height: "40px",
                borderRadius: "8px",
              }}
              variant="contained"
              color="primary"
              onClick={handleOpenFilterModal}
            >
              <FilterAltIcon />
            </Button>
          </Tooltip>
          <FilterModal
            anchorEl={anchorEl}
            onClose={handleCloseFilterModal}
            onFilter={handleFilterApply}
            initialFilters={filters}
          />
          {AuthService.hasPermission("update", "movement_out") &&
            selectedPendingIds.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<ReceiptLongIcon />}
                onClick={handleOpenBulkDialog}
                sx={{
                  ml: "auto",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
              >
                Preparar seleccionados ({selectedPendingIds.length})
              </Button>
            )}
        </Paper>

        {(searchText ||
          selectedOperativa ||
          selectedIntegration ||
          selectedProvince ||
          filters.from ||
          filters.to) && (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 1,
              mb: 2,
            }}
          >
            <Typography variant="caption" sx={{ color: "#888" }}>
              Filtros activos:
            </Typography>
            {searchText && (
              <Chip
                size="small"
                label={`Buscar: ${searchText}`}
                onDelete={clearSearchFilter}
              />
            )}
            {selectedOperativa && (
              <Chip
                size="small"
                label={`Operativa: ${selectedOperativa.label}`}
                onDelete={clearOperativaFilter}
              />
            )}
            {selectedIntegration && (
              <Chip
                size="small"
                label={`Canal: ${selectedIntegration.label}`}
                onDelete={clearCanalFilter}
              />
            )}
            {selectedProvince && (
              <Chip
                size="small"
                label={`Provincia: ${selectedProvince}`}
                onDelete={clearProvinceFilter}
              />
            )}
            {(filters.from || filters.to) && (
              <Chip
                size="small"
                label={`Fecha: ${(filters.from || "").slice(0, 10) || "…"} → ${
                  (filters.to || "").slice(0, 10) || "…"
                }`}
                onDelete={clearDateFilter}
              />
            )}
            <Typography
              variant="caption"
              onClick={clearAllFilters}
              sx={{
                color: "#2563EB",
                cursor: "pointer",
                fontWeight: 600,
                ml: 0.5,
              }}
            >
              Limpiar todo
            </Typography>
          </Box>
        )}

        <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
        {/* Tabs por estado con contador (reemplazan el dropdown de Estado) */}
        <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
          {[
            { key: undefined, label: "Todos" },
            { key: "pending", label: "Pendientes" },
            { key: "in_progress", label: "En proceso" },
            { key: "prepared", label: "Preparados" },
            { key: "done", label: "Despachados" },
          ].map((tab) => {
            const active = (filters.status || undefined) === tab.key;
            const count = tab.key
              ? statusCounts[tab.key] || 0
              : Object.values(statusCounts).reduce((a, b) => a + b, 0);
            return (
              <Box
                key={tab.label}
                onClick={() => {
                  setSelectedPendingIds([]);
                  setPaginacion((prev) => ({ ...prev, page: 1 }));
                  if (tab.key) setFilters(({ tracking, ...f }) => ({ ...f, status: tab.key }));
                  else setFilters(({ status, tracking, ...rest }) => rest);
                }}
                sx={{
                  cursor: "pointer",
                  px: 2,
                  py: 0.8,
                  borderRadius: "8px",
                  border: active ? "1px solid #2563EB" : "1px solid #e2e8f0",
                  backgroundColor: active ? "#E8F0FE" : "#fff",
                  color: active ? "#2563EB" : "#475569",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.7,
                }}
              >
                {tab.label}
                <Box
                  component="span"
                  sx={{
                    backgroundColor: active ? "#2563EB" : "#e2e8f0",
                    color: active ? "#fff" : "#64748b",
                    borderRadius: "10px",
                    px: 0.9,
                    fontSize: "0.72rem",
                    fontWeight: 700,
                    minWidth: 18,
                    textAlign: "center",
                  }}
                >
                  {count}
                </Box>
              </Box>
            );
          })}
        </Box>

        {/* Sub-filtros de SEGUIMIENTO dentro de Despachados: capa "correo" (ML) sobre
            el flujo del depósito. ¿Cuáles ya llegaron? ¿cuáles están en camino? */}
        {filters.status === "done" && (
          <Box sx={{ display: "flex", gap: 0.8, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
            <Typography variant="caption" sx={{ color: "#94a3b8", fontWeight: 600, mr: 0.3 }}>
              Seguimiento:
            </Typography>
            {TRACKING_SUBFILTERS.map((sf) => {
              const active = (filters.tracking || undefined) === sf.key;
              return (
                <Box
                  key={sf.label}
                  onClick={() => {
                    setPaginacion((prev) => ({ ...prev, page: 1 }));
                    if (sf.key) setFilters((f) => ({ ...f, tracking: sf.key }));
                    else setFilters(({ tracking, ...rest }) => rest);
                  }}
                  sx={{
                    cursor: "pointer",
                    px: 1.4,
                    py: 0.4,
                    borderRadius: "14px",
                    border: active ? "1px solid #2563EB" : "1px solid #e2e8f0",
                    backgroundColor: active ? "#E8F0FE" : "#fff",
                    color: active ? "#2563EB" : "#64748b",
                    fontWeight: 600,
                    fontSize: "0.78rem",
                  }}
                >
                  {sf.label}
                </Box>
              );
            })}
          </Box>
        )}

        {/* Lista en cards */}
        {buscandoEgresos ? (
          <Box sx={{ textAlign: "center", py: 6, color: "#64748b" }}>Buscando egresos...</Box>
        ) : listadoDeEgresos.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 6, color: "#64748b" }}>No hay egresos disponibles</Box>
        ) : (
          <Box>{listadoDeEgresos.map((row) => renderEgressCard(row))}</Box>
        )}

        <TablePagination
          component="div"
          count={paginacion.total || 0}
          page={paginacion.page - 1 || 0}
          rowsPerPage={paginacion.pageSize || 10}
          onPageChange={(event, newPage) => {
            setSelectedPendingIds([]);
            setPaginacion((prev) => ({ ...prev, page: newPage + 1 }));
            fetchAllEgresos(newPage + 1, paginacion.pageSize);
          }}
          onRowsPerPageChange={(event) => {
            setSelectedPendingIds([]);
            const newSize = parseInt(event.target.value, 10);
            setPaginacion((prev) => ({ ...prev, pageSize: newSize, page: 1 }));
            fetchAllEgresos(1, newSize);
          }}
          labelRowsPerPage="Por página:"
          rowsPerPageOptions={[10, 25, 50]}
        />
        </Box>
        <Dialog
          open={openCancelModal}
          onClose={handleCloseCancelModal}
          aria-labelledby="egress-cancel-dialog-title"
          aria-describedby="egress-cancel-dialog-description"
          PaperProps={{ sx: { borderRadius: "12px", p: 1 } }}
        >
          <DialogTitle id="egress-cancel-dialog-title" sx={{ fontWeight: 600 }}>
            Cancelar egreso
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="egress-cancel-dialog-description" sx={{ color: "#555" }}>
              ¿Estás seguro de que deseas cancelar este egreso? Esta acción no se puede deshacer.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
            <Button
              onClick={handleCloseCancelModal}
              variant="outlined"
              disabled={cancelingEgress}
              sx={{ borderRadius: "8px", textTransform: "none" }}
            >
              Volver
            </Button>
            <Button
              onClick={handleConfirmCancelEgress}
              color="error"
              variant="contained"
              disabled={cancelingEgress}
              sx={{ borderRadius: "8px", textTransform: "none" }}
            >
              {cancelingEgress ? "Cancelando…" : "Confirmar cancelación"}
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={alertObj?.severity}
            sx={{ width: "100%" }}
          >
            {alertObj.message}
          </Alert>
        </Snackbar>
        <EgressLimitModal
          open={Boolean(limitModal)}
          onClose={() => setLimitModal(null)}
          plan={limitModal?.plan}
          limit={limitModal?.limit}
          used={limitModal?.used}
        />
        <ModalAccepted
          open={modalPending}
          loading={loading}
          onClose={handleCloseDialog}
          count={bulkAcceptMode ? selectedPendingIds.length : 1}
          onConfirm={() => {
            if (bulkAcceptMode) {
              handleBulkAccept();
            } else {
              handleConfirm("in_progress");
            }
          }}
        />
        <ModalDispatched
          loading={loading}
          open={modalDispatched}
          onClose={handleCloseDispatched}
          onConfirm={() => {
            handleConfirm("done");
          }}
        />
        <ModalPrepared
          ingressDetail={movementDetails}
          scanOnPrepare={scanOnPrepare}
          shippingMethod={ingressDetail?.shipping_method || ingressDetail?.logistics?.shippingMethod}
          loading={loading}
          open={modalDone}
          onClose={handleCloseDone}
          onConfirm={(packages) => {
            // red_despacho: los bultos vienen de la creación (preparePackages); el resto
            // de operativas los carga el operario acá. Se mandan con el update a
            // "prepared" (el backend reescribe movement_package; nunca mandar []).
            const sm = ingressDetail?.shipping_method || ingressDetail?.logistics?.shippingMethod;
            const finalPackages =
              sm === "red_despacho"
                ? preparePackages
                : Array.isArray(packages)
                  ? packages
                  : [];
            handleConfirm("prepared", {
              ...ingressDetail,
              packages: finalPackages,
              package_count: Array.isArray(finalPackages) ? finalPackages.length : 0,
            });
          }}
        />
        <ModalView
          ingressDetail={ingressDetail}
          open={modalView}
          onClose={handleCloseModalView}
          onLabelPrinted={(id) => markEgressLabelPrinted({ id })}
        />
        {labelsToPrint && labelsToPrint.length > 0 && (
          <EgressLabelPrinter
            labels={labelsToPrint}
            onPrintComplete={() => {
              setLabelsToPrint([]);
            }}
          />
        )}
      </Grid>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
        onClick={() => setOpenBackdrop(false)}
      >
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
          <CircularProgress color="inherit" />
        </Box>
      </Backdrop>
    </>
  );
};

export default ListadoEgresos;
